import React from 'react';
import {CuvetteLidIcon} from '../../Icons';
import {CuvetteTooltip} from './CuvetteTooltip';
import className from './style.module.scss';
import {Image} from '@learningblocks/shared-components';

export function CuvetteLid(props) {
  const [hover, setHover] = React.useState(false);

  const toggleHover = (value) => () => setHover(value);

  return (
    <div
      tabIndex='0'
      onMouseEnter={toggleHover(true)}
      onMouseLeave={toggleHover(false)}
      className={className.cuvetteLid}>
      <CuvetteTooltip selected={hover} buttonList={ props.buttonList }/>
      <Image src={CuvetteLidIcon} alt='cuvette-lid-image' />
    </div>
  );
}

CuvetteLid.propTypes = {};

CuvetteLid.defaultProps = {};
